import type { GQL_ID } from '@@partner:types:graphql'
import type { File } from './common'

export enum MenuType {
  header = 'header',
  footer = 'footer',
  sidebar = 'sidebar',
  mobile = 'mobile'
}

export enum LinkType {
  internal = 'internal',
  external = 'external',
  category = 'category',
  product = 'product'
}

export interface MenuItemTranslation {
  language_code: string
  title: string
}

export interface MenuItem {
  id: GQL_ID
  menu_id: GQL_ID
  internal_name: string
  title: string
  image_file_id?: GQL_ID
  icon_code?: string
  icon_color?: string
  text_color?: string
  link_url?: string
  link_type: LinkType
  bold: boolean
  is_active: boolean
  sort_order: number
  created_at: string
  updated_at: string
  
  // Relations
  menu?: Menu
  image?: File
  translations: MenuItemTranslation[]
  i18n?: MenuItemTranslation[]
}

export interface Menu {
  id: GQL_ID
  name: string
  code: string
  type: MenuType
  is_active: boolean
  created_at: string
  updated_at: string
  
  // Relations
  menuItems: MenuItem[]
  
  // Computed fields
  menuItemsCount?: number
}

export interface MenusEdge {
  edges: Menu[]
  pageInfo: {
    page: number
    perPage: number
    lastPage: number
    next?: number
    total: number
  }
}
